<!-- Start: Rejwan: 08-12-2025 Gf Summery -->
<template>
	<div>
        <div class="row">                
            <div class="row col-12 no-margin">
                <div class="ibox col-md-12 border-0">
                    <div class="ibox-title dashboard_title">
                        <h4 class="clearfix">
                            <span class="float-left">Gratuity Fund Summary<span class="title-sub-text">A comprehensive overview of potential gratuity amount to be received till date:</span></span>
                            <span class="float-right"></span>
                        </h4>
                    </div>
                    <div class="ibox-content">
                        
                        <template>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 cursor-pointer">
                                    <table class="w-100">
                                        <thead>
                                            <tr class="table-head">
                                                <th scope="col">Particulars</th>
                                                <th class="text-right" scope="col">Details</th>													
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template>
                                                <tr class="table-row">
                                                    <td class="font-semi-bold">Joining date</td>
                                                    <!-- {{ summaryData }} -->
                                                    <td class="text-right font-semi-bold">{{ summaryData.joining_date }}</td>														
                                                </tr>
                                                <tr class="table-row" v-if="summaryData.last_working_date">
                                                    <td>Last working date</td>
                                                    <td class="text-right">{{ summaryData.last_working_date }}</td>
                                                </tr>
                                                <tr v-else>
                                                    <td>Today's date</td>
                                                    <td class="text-right">{{ summaryData.today_date }}</td>
                                                </tr>
                                                <tr class="table-row">
                                                    <td>Lenght of service in years</td>
                                                    <td class="text-right">{{ summaryData.length_of_service_years }}</td>														
                                                </tr>
                                                <tr class="table-row">
                                                    <td>Eligible length of service in years</td>
                                                    <td class="text-right">{{ summaryData.eligible_length_of_service_years }}</td>														
                                                </tr>
                                                <tr class="table-row">
                                                    <td class="font-semi-bold">Latest Basic Salary</td>
                                                    <td class="text-right font-semi-bold">{{ summaryData.latest_basic_salary }}</td>														
                                                </tr>
                                                <tr class="table-row">
                                                    <td class="font-semi-bold">Potential GF Balance</td>
                                                    <td class="text-right font-semi-bold">{{ summaryData.potential_gf_balance }}</td>														
                                                </tr>
                                            </template>            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </template>
                        <!-- Start: Rejwan: 09-12-2025 Pf and gf statement -->
                        <div class="col-lg-12 col-md-12 col-sm-12 cursor-pointer text-center">
                            <b-button class="mt-5" @click="downloadGfStatement()">
                                Download GF Statement
                            </b-button>
                        </div>
                        <!-- End: Rejwan: 09-12-2025 Pf and gf statement -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
 export default{    
    data() {
        return {
            showoverlay : true,
            summaryData: null,
        }
    },
    methods:{
        
        showContent: function()
        {
            this.showoverlay = false;
        },

        getGfSummery() {
            let currentObj = this;
            currentObj.showoverlay = true;

            axios.get(this.$api_url + '/gf/employee-gf-summary')
            .then(function(response) {
                currentObj.summaryData = response.data;
                currentObj.showoverlay = false;
            })
            .catch(function(error) {
                currentObj.serverError(error);
                currentObj.showoverlay = false;
            });
        },
        
        // Start: Rejwan: 09-12-2025 Pf and gf statement
        downloadGfStatement: function()
        {
            this.downloadBlobResponse(
                axios.post(this.$api_url + '/gf/download-gf-statement', {}, { responseType: 'blob' }),
                'showoverlay' // your loader key in this component
            );
        },
        // End: Rejwan: 09-12-2025 Pf and gf statement
    },
    created: function(){
        this.getGfSummery();
    }

}
</script>
<!-- End: Rejwan: 08-12-2025 Gf Summery -->